<template>
  <div>
    <Hero>
      <strong>
        Работайте с лучшими,
      </strong>
      <br>
      <em>
        в лучших условиях
      </em>
    </Hero>

    <TeamOffer />

    <TeamCulture />

    <TeamVideos />

    <TeamTeam />
  </div>
</template>

<script>
import Hero from 'components/Hero';

const TeamOffer = () => import('components/TeamOffer');
const TeamCulture = () => import('components/TeamCulture');
const TeamVideos = () => import('components/TeamVideos');
const TeamTeam = () => import('components/TeamTeam');
const TeamSocial = () => import('components/TeamSocial');
const TeamOffices = () => import('components/TeamOffices');

export default {
  name: 'Team',
  components: {
    TeamOffices,
    TeamSocial,
    Hero,
    TeamOffer,
    TeamCulture,
    TeamVideos,
    TeamTeam,
  },
};
</script>



// WEBPACK FOOTER //
// src/views/Team.vue